module.exports = __webpack_public_path__ + "img/agma2015-2-B15_fig02_agma-classification-specification.dc0a9124.png";